import { store } from '@/decorators/store';
import { AbstractEntityStore } from '@/stores/AbstractEntityStore';
import { IAlertInfo } from '~/api/IAlertInfo';

@store({ id: 'AlertStore' })
export class AlertStore extends AbstractEntityStore<IAlertInfo> {
  protected entityIdKey = 'alertId';
  protected entityValueKey = 'alertText';
}
